// src/components/Policies/CookiePolicy.js

import React, { useEffect } from 'react';

const CookiePolicy = () => {
  useEffect(() => {
    if (!document.getElementById('termly-jssdk')) {
      const script = document.createElement('script');
      script.id = 'termly-jssdk';
      script.type = 'text/javascript';
      script.src = 'https://app.termly.io/embed-policy.min.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div>
      <div
        name="termly-embed"
        data-id="59ae13a1-ca7e-47b5-89d3-851fb86fff8c"
      ></div>
    </div>
  );
};

export default CookiePolicy;
